export const routesApp = {
    home: '/app',
    registration: '/app/registration/step/:stepNumer',
    registrationV2: '/app/registrationV2/step/:stepNumer',
    registrationV3: '/app/registrationV3/step/:stepNumer',
    registrationV4: '/app/registrationV4/step/:stepNumer',
    browse: '/app/browse',
    messages: '/app/messages',
    chat: '/app/messages/chat/:id',
    liked: '/app/liked',
    settings: '/app/profile/settings',
    profile: '/app/profile',
    subscription: '/app/profile/subscription',
    webSub: '/app/profile/subscription/web',
    profileEdit: '/app/profile/edit',
    profileView: '/app/profile-view/:id',
    termsOfService: '/app/profile/terms-of-service',
    banned: '/app/banned',
    myFormPreview: '/app/profile/my-form-preview',
    index: '/',
} as const;
